/**
 * Command-menu filter: every whitespace-separated search token must appear as
 * a substring of the item's value or keywords. Word-start matches rank higher.
 * Less surprising than fuzzy subsequence matching ("ord" won't match "Dashboard").
 */
export function substringFilter(value: string, search: string, keywords?: string[]): number {
  const hay = [value, ...(keywords ?? [])].join(' ').toLowerCase()
  const tokens = search.toLowerCase().trim().split(/\s+/).filter(Boolean)
  if (tokens.length === 0) return 1
  let score = 0
  for (const t of tokens) {
    const i = hay.indexOf(t)
    if (i < 0) return 0
    score += i === 0 || /[\s./_-]/.test(hay[i - 1] ?? '') ? 2 : 1
  }
  return score / (tokens.length * 2)
}
